
var width = jQuery(window).width();
gsap.registerPlugin(ScrollTrigger, scrollTo);


function scrollGSAP(){
    
    (function($) {
    
    
            //Breakpoints
            const xs = 0;
            const sm = 576;
            const md = 768;
            const lg = 992;
            const xl = 1200;
            const xxl = 1400;
            const xxxl = 1600;
            const xxxxl = 1800;
            
            
            const header_height = 59;
    
            //media
            const media_desktop = "(min-width: "+md+"px)";
            const media_mobile = "(max-width: "+md+"px)";
    
            let w_width = $(window).width();
            let w_height = $(window).height();
            let w_height_net = w_height - header_height;
            $(window).resize(function(){
                w_width = $(window).width();
                w_height = $(window).height();
                //w_height_net = w_height - header_height;
                w_height_net = w_height;
            });
            
            $(window).on('resize touchmove', function () {
                w_width = $(window).width();
                w_height = $(window).height();
                //w_height_net = w_height - header_height;
                w_height_net = w_height;
            });
    
            //Animazione gsap-1
            if($("#gsap-1").length != 0){ 
                
    
    
                //configurazione iniziale
    
                let childrens = 0;  
                function init_initial_configuration(){ 
    
                    
    
                    //init slider
                    
                    $('.slide-section').children().each(function(){
                        childrens++;
                    });
    
                    let children = 0;
                    $('.slide-section').children().each(function(){
                        $(this).css('left', 100 / childrens * children + '%');
                        children ++;
                    });
                    
                    $('.slide-section').css('width', 100* childrens + '%');
    
                    
    
                    //imposto le colonne
                    if(window.matchMedia(media_desktop).matches){
    
                        $('.section-1').css('width','50vw');
                        $('.section-2').css('width','50vw');
                        $('.section-1').css('height','100vh');
                        $('.section-2').css('height','100vh');
    
                    
                    }else{
    
                        $('.section-1').css('height','calc((100vh - ' + header_height + ')/2)');
                        $('.section-2').css('height','calc((100vh - ' + header_height + ')/2)');
                        $('.section-1').css('width','100vw');
                        $('.section-2').css('width','100vw');
               
                   
                    }
                    
                }
    
                init_initial_configuration();
                $(window).on('resize touchmove', function () {
                    init_initial_configuration();
                }); 
    
    
                     
    
    
    
    
                //definizione dei triggers
    
                const trigger_0 = gsap.timeline({
                    scrollTrigger: {
                      trigger: "#trigger-0",
                      start: "center bottom",
                      end: "center top",
                      scrub: true,
                      //markers: true
                    }
                });
    
                const trigger_1 = gsap.timeline({
                    scrollTrigger: {
                        trigger: "#trigger-1",
                        start: "top bottom",
                        end: "bottom top",
                        scrub: true,
                        //markers: true
                    }
                });
    
                const trigger_1_half = gsap.timeline({
                    scrollTrigger: {
                        trigger: "#trigger-1",
                        start: "top center",
                        end: "top top",
                        scrub: true,
                        //markers: true
                    }
                });
    
                const trigger_2 = gsap.timeline({
                    scrollTrigger: {
                        trigger: "#trigger-2",
                        start: "top top",
                        end: "bottom top",
                        //scroller: "viewport",
                        scrub: true,
                        //markers: true
                    }
                });
    
                const trigger_3 = gsap.timeline({
                    scrollTrigger: {
                        trigger: "#trigger-3",
                        start: "top center",
                        end: "bottom top",
                        scrub: true,
                      //markers: true
                    }
                });
    
                const trigger_4 = gsap.timeline({
                        scrollTrigger: {
                        trigger: "#trigger-4",
                        start: "top top",
                        end: "bottom top",
                        scrub: true,
                        //markers: true
                    }
                });
    
    
                //associazione animazioni ai triggers
    
                
                ScrollTrigger.matchMedia({
    
                    //breakpoint md - desktop
                    "(min-width: 768px)" : function(){
    
                        //slider
                        trigger_1.to('.slide-section', {
                            left: '-' + 100 * (childrens - 1) + '%',
                        });
    
                        trigger_1_half.to('#section-2_1', {
                            opacity:0
                        });
    
    
                        //allargo colonna immagini
                        trigger_2.to('.section-2',{
                            width: '100vw',
                            //width: w_width,
                        });
    
                        //stringo colonna testi
                        trigger_2.to('.section-1',{
                            width:0,
                        });
                        
                        
                        trigger_3.to('#section-2_2', {
                            opacity :0,
                        });
                        
                        trigger_4.to('#section-2_4', {
                            opacity :1,
                            
                        });
    
                    
    
    
                    },
    
    
    
    
                    //breakpoint md - mobile
                    "(max-width: 768px)" : function(){
    
                        //slider
                        trigger_1.to('.slide-section', {
                            left: '-' + 100 * (childrens - 1) + '%',
                        });
    
                        trigger_1_half.to('#section-2_1', {
                            opacity:0
                        });
    
    
                         //stringo colonna testi
                         trigger_2.to('.section-1',{
                            height:0,
                        });
    
    
                        //allargo colonna immagini
                        trigger_2.to('.section-2',{
                            //height: '100vh',
                            height: w_height_net,
                            //width: w_width,
                        });
    
                       
                        
                        trigger_3.to('#section-2_2', {
                            opacity :0,
                        });
                        
                        trigger_4.to('#section-2_4', {
                            opacity :1,
                        });
                        
    
                    
    
    
                    },
    
    
    
    
                });
    
                
    
    
            }
    
    
    
    
    
            if($("#gsap-2").length != 0){
    
    
                const gsap2_trigger0 = gsap.timeline({
                    scrollTrigger: {
                      trigger: "#gsap-2-trigger-0",
                      start: "top top",
                      end: "bottom center",
                      scrub: true,
                      //markers: true
                    }
                });
    
    
    
                const gsap2_trigger0_1 = gsap.timeline({
                    scrollTrigger: {
                      trigger: "#gsap-2-trigger-0",
                      start: "top center",
                      end: "top top",
                      scrub: true,
                      //markers: true
                    }
                });
    
                const gsap2_trigger0_2 = gsap.timeline({
                    scrollTrigger: {
                      trigger: "#gsap-2-trigger-0",
                      start: "bottom center",
                      end: "bottom top",
                      scrub: true,
                      //markers: true
                    }
                });
    
                const gsap2_trigger1 = gsap.timeline({
                    scrollTrigger: {
                      trigger: "#gsap-2-trigger-1",
                      start: "bottom bottom",
                      end: "bottom top",
                      scrub: true,
                      //markers: true
                    }
                });
    
                
    
                gsap2_trigger0_1.to('#section_2_title',{
                    opacity: 1,
                    top: '10%'
                });
    
                gsap2_trigger0.to('#section_1_background',{
                    opacity: 0,
                });
    
                gsap2_trigger0_2.to('#section_3_image', {
                    bottom: 0,
                    opacity: 1,
                    width: '100%',
                    left: 0
                });
    
                gsap2_trigger1.to('#section_4_content', {
                    opacity: 1,
                    top: '30%'
                });
    
            }
    
            //end gsap 2
    
            //gsap 3
    
            
            
            if($(".gsap-3").length != 0){
    
                const pages = $('#gsap_3_page_counter').attr('data-gsap3');
    
                
                
                for(i = 1; i <= pages; i++){
        
                    
                    const trigger_image = gsap.timeline({
                        scrollTrigger: {
                            trigger: ".gsap_page_" + i +" .gsap-3-trigger-0",
                            start: "top center",
                            end: "bottom top",
                            scrub: true,
                            //markers: true
                          }
                    });
    
                    trigger_image.to('.gsap_page_' + i +' .image-container', {
                        top: '50%',
                    });
        
                    gsap.to('.gsap_page_' + i +' .background-container', {
                        background: '#FFFFFF',
                        scrollTrigger: {
                            trigger: ".gsap_page_" + i +" .gsap-3-trigger-0",
                            
                            start: "bottom center",
                            end: "bottom center",
                            scrub: true,
                            //markers: true
                          }
                    });
    
                    const trigger_content = gsap.timeline({
                        scrollTrigger: {
                            trigger: ".gsap_page_" + i +" .gsap-3-trigger-1",
                            start: "top top",
                            end: "bottom top",
                            scrub: true,
                            //markers: true
                          }
                    });
    
                    trigger_content.to('.gsap_page_' + i +' .title-container', {
                        top:'5%',
                        opacity: 1,
                    });
    
                    trigger_content.to('.gsap_page_' + i +' .content-container', {
                        top:'11%',
                        opacity: 1,
                    });
    
                    
                    gsap.to('.gsap_page_' + i +' .button-container', {
                        top:'85%',
                        opacity: 1,
                        scrollTrigger: {
                            trigger: ".gsap_page_" + i +" .gsap-3-trigger-3",
                            start: "top center",
                            end: "center top",
                            scrub: true,
                            //markers: true
                          }
                    });
                    
    
    
                    ScrollTrigger.matchMedia({
    
                        //breakpoint md - desktop
                        "(min-width: 768px)" : function(){
    
                            trigger_image.to('.gsap_page_' + i +' .image-container', {
                                width:'50%',
                                height: '50%',
                            });
    
                        },
                        "(max-width: 768px)" : function(){
    
                            trigger_image.to('.gsap_page_' + i +' .image-container', {
                                width:'90%',
                                height: '40%',
                                top: '60%'
                            });
    
                            
                        }
                    });
    
                }
    
    
    
            }
    
            if($(".hero-image").length != 0){
    
                
    
                for(c=1; c<= $(".hero-image").length; c++){
    
                
    
                const hero_trigger_1 = gsap.timeline({
                    scrollTrigger: {
                        trigger: '#hero-image-trigger-' + c +  ' .hero-trigger-1',
                        start : "top top",
                        end : "bottom top",
                        scrub : true
                    }
                });
    
                
    
    
                hero_trigger_1.to('#hero-image-trigger-' + c +  ' .hero-image .image', {
                    width: '100%',
                    height: '100vh',
                    marginLeft: 0,
                    paddingTop: 0
    
                });
    
                hero_trigger_1.to('#hero-image-trigger-' + c +  ' .hero-image .gradient-overlay', {
                    opacity: 1
    
                });
    
                hero_trigger_1.to('#hero-image-trigger-' + c +  ' .hero-image .center-content', {
                    opacity: 1
                });
    
                if($('#hero-image-trigger-' + c +  ' .hero-image .image2').length != 0){
    
                    hero_trigger_1.to('#hero-image-trigger-' + c +  ' .hero-image .image2', {
                        opacity: 1
                    });
    
                    hero_trigger_1.to('#hero-image-trigger-' + c +  ' .hero-image .gradient-overlay', {
                        opacity: 0
        
                    });
    
                }
    
                }
    
    
            }
    
    
    
            if($(".hero-gallery").length != 0){
    
                
    
                for(c=1; c<= $(".hero-gallery").length; c++){
    
                const items = parseInt($('#hero-gallery-trigger-' + c).attr('data-items'));
    
    
                const hero_gallery_trigger_1 = gsap.timeline({
                    scrollTrigger: {
                        trigger: '#hero-gallery-trigger-' + c +  ' .hero-trigger-1',
                        start : "top top",
                        end : "bottom top",
                        scrub : true,
                        //onEnter: ({progress, direction, isActive}) => $('#hero-gallery-trigger-' + c +  ' .hero-gallery .image0 .title-animation').textillate('start'),
                        onEnter: ({progress, direction, isActive}) => console.log('trigger fired'),
                        onEnterBack: ({progress, direction, isActive}) => $('#hero-gallery-trigger-' + c +  ' .hero-gallery .image0 .title-animation').textillate('start'),
                    }
                });
    
                
    
                
    
                hero_gallery_trigger_1.to('#hero-gallery-trigger-' + c +  ' .hero-gallery .image0', {
                    width: '100%',
                    height: '100vh',
                    marginLeft: 0,
                    paddingTop: 0
    
                });
                
    
    
                for(i = 1; i < items; i++){
    
                    const panels = gsap.utils.toArray('#hero-gallery-trigger-' + c +  ' .hero-gallery .panel');
                    const side_section = $('#hero-gallery-trigger-' + c + ' .side-section');
    
    
                    tween = gsap.to(panels, {
                        xPercent: -100 * ( panels.length - 1 ),
                        ease: "none",
                        scrollTrigger: {
                            trigger: '#hero-gallery-trigger-' + c +  ' .page-0',
                            pin: true,
                            start: "top top",
                            scrub: 1,
                            snap: {
                                snapTo: 1 / (panels.length - 1),
                                inertia: false,
                                duration: {min: 0.1, max: 0.1}
                            },
                            end: () =>  "+=" + (side_section.height())
                        }
                    });
    
                    /*
                    gsap.to('#hero-gallery-trigger-' + c +  ' .hero-gallery .image' + i, {
                        scrollTrigger: '#hero-gallery-trigger-' + c +  ' .page-' + i,
                        left: 0
                    });
                    */
    
                    /*
                    hero_gallery_trigger_1.to('#hero-gallery-trigger-' + c +  ' .hero-gallery .image' + i, {
                        left: 0
    
                    });
                    */
    
                }
    
    
    
                }
    
    
            }
    
            
    
            if($(".three-image-section").length != 0){
    
                for(tis=1; tis<= $(".three-image-section").length; tis++){
    
                    const trigger_shining = gsap.timeline({
                        scrollTrigger: {
                            trigger: '#three-image-trigger-' + tis,
                            start : "top bottom",
                            end : "bottom top",
                            scrub : true
                        }
                    });
    
                    const trigger_shining_2 = gsap.timeline({
                        scrollTrigger: {
                            trigger: '#three-image-trigger-' + tis,
                            start : "top bottom",
                            end : "bottom top",
                            scrub : true
                        }
                    });
    
                    const trigger_content_1 = gsap.timeline({
                        scrollTrigger: {
                            trigger: '#three-image-trigger-' + tis +' .content-1',
                            start : "top bottom",
                            end : "top top",
                            scrub : true
                        }
                    });
    
                    const trigger_image_1 = gsap.timeline({
                        scrollTrigger: {
                            trigger: '#three-image-trigger-' + tis +' .image-1',
                            start : "top bottom",
                            end : "top top",
                            scrub : true
                        }
                    });
    
                    const trigger_image_2 = gsap.timeline({
                        scrollTrigger: {
                            trigger: '#three-image-trigger-' + tis +' .image-2',
                            start : "top bottom",
                            end : "top top",
                            scrub : true
                        }
                    });
    
                    const trigger_image_3 = gsap.timeline({
                        scrollTrigger: {
                            trigger: '#three-image-trigger-' + tis +' .image-3',
                            start : "top bottom",
                            end : "top top",
                            scrub : true
                        }
                    });
    
                    const trigger_content_2 = gsap.timeline({
                        scrollTrigger: {
                            trigger: '#three-image-trigger-' + tis +' .content-2',
                            start : "top bottom",
                            end : "top top",
                            scrub : true
                        }
                    });
    
                    trigger_shining.to('#three-image-trigger-' + tis +' .shining', {
                        left: '100%'
                    });
    
                    
                    trigger_shining_2.to('#three-image-trigger-' + tis +' .shining2', {
                        right: '100%'
                    });
                    
                    
                    trigger_content_1.to('#three-image-trigger-' + tis +' .content-1', {
                        opacity: 1,
                        left: 0
                    });
    
                    trigger_image_1.to('#three-image-trigger-' + tis +' .image-1', {
                        top: 0,
                    });
    
                    trigger_image_2.to('#three-image-trigger-' + tis +' .image-2', {
                        top: 0,
                    });
    
                    trigger_image_3.to('#three-image-trigger-' + tis +' .image-3', {
                        //top: '-2rem',
                    });
    
                    trigger_content_2.to('#three-image-trigger-' + tis +' .content-2', {
                        opacity: 1,
                        left: 0
                    });
                    
                }
    
            }
            
    
            if($("#gsap-transition-to-white").length != 5){
    
    
                const trigger_transition2white = gsap.timeline({
                    scrollTrigger: {
                        trigger: '#gsap-transition-to-white',
                        start: "top top",
                        end: "top top",
                        scrub : true,
                        //toggleClass: "background-modified",
                        onEnter: ({progress, direction, isActive}) => $('#gsap-transition-to-white').addClass('trigger-fired'),
                        onEnterBack: ({progress, direction, isActive}) => $('#gsap-transition-to-white').removeClass('trigger-fired'),
                    }
                });
    
    
                trigger_transition2white.to('#gsap-transition-to-white', {
                    //background: 'white'
                }); 
    
    
            }

            if ($(".scroll-text-to-image").length != 0) {
                $(".scroll-text-to-image").each(function() {
                    const triggerElement = $(this).find('.content-text');
                    const triggerContainer = $(this).find('.animation-section');
                    const triggerHeight = triggerElement.outerHeight();

                    const trigger_text_image_1 = gsap.timeline({
                        scrollTrigger: {
                            trigger: triggerElement,
                            start: "bottom 80%",
                            end: "bottom top",
                            scrub: true
                        }
                    });

                    const trigger_text_image = gsap.timeline({
                        scrollTrigger: {
                            trigger: triggerContainer,
                            start: "top -" + triggerHeight + "px",
                            end: "bottom bottom",
                            scrub: true
                        }
                    });

                    trigger_text_image_1.to($(this).find('.wrapper-images'), {
                        y: 0,
                        scale: 1.2,
                        duration: 3,
                    });
                    
            
                    trigger_text_image.to($(this).find('.wrapper-images'), {
                        scale: 3,
                        duration: 6,
                    });

                    trigger_text_image.from($(this).find('.wrapper-cta'), {
                        opacity: 0,
                        duration: 2,
                    });
                });
            }

            if ($(".scroll-image-to-text").length != 0) {
                $(".scroll-image-to-text").each(function() {
                    var animation_text =  $(this).find('.wrapper-text');

                    var tl = gsap.timeline({
                        scrollTrigger: {
                            trigger: $(this).find('.content-image'),
                            start: "top top",
                            end: "bottom bottom",
                            scrub: true,
                            reverse: true,
                        },
                    });

                    tl.to($(this).find('.wrapper-image'), {
                        height: "65vh",
                    });

                    tl.to(animation_text.find('h2'), {
                        scale: 0.7,
                        color: "#3e3e3e",
                    }, 0);

                    tl.to(animation_text.find('p'), {
                        opacity: 1,
                    });
                });
            }

            if($(".horizontal-gallery").length != 0){
                
    
                for(c=1; c<= $(".horizontal-gallery").length; c++){
    
                    const items = parseInt($('#hero-gallery-trigger-' + c).attr('data-items')); 

                    const horizontal_gallery_trigger_1 = gsap.timeline({
                        scrollTrigger: {
                            trigger: '#hero-gallery-trigger-' + c +  ' .hero-trigger-1',
                            start : "top top",
                            end : "bottom top",
                            scrub : true,
                            onEnter: ({progress, direction, isActive}) => console.log('trigger fired'),
                            onEnterBack: ({progress, direction, isActive}) => $('#hero-gallery-trigger-' + c +  ' .horizontal-gallery .title-animation').textillate('start'),
                        }
                    });
                    
                    for(i = 1; i < items; i++){
        
                        const panels = gsap.utils.toArray('#hero-gallery-trigger-' + c +  ' .horizontal-gallery .panel');
                        const side_section = $('#hero-gallery-trigger-' + c + ' .side-section');
        
        
                        tween = gsap.to(panels, {
                            xPercent: -100 * ( panels.length - 1 ),
                            ease: "none",
                            scrollTrigger: {
                                trigger: '#hero-gallery-trigger-' + c +  ' .side-section',
                                pin: false,
                                start: "top top",
                                scrub: 1,
                                end: () => `+=${side_section.outerHeight() - (1.5 * window.innerHeight)}`
                            }
                        }); 
        
                    }


                }
    
    
            }
    
    })
    (jQuery);

}



